import {

  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Container, Spinner, Table } from "react-bootstrap";
import { ToastContainer } from "react-toastify";
import notify from "../../../Notifcation";
import { useDispatch, useSelector } from "react-redux";
import {
  UpdateEmpAction,
  createNewEmpAction,
  gelEmployeesAction,
} from "../../../redux/actions/ManageempAction";

const Employee = () => {
  const [loading, setLoading] = useState(true);
  const [isPress, setisPress] = useState(false);
  const [Name, setName] = useState("");
  const [Nationalid, setNationalid] = useState("");
  const [Phone, setPhone] = useState("");
  const [Address, setAddress] = useState("");
  const [Email, setEmail] = useState("");
  const [EmpId, setEmpId] = useState("");
  const [DeleteEmp, setDeleteEmp] = useState("");
  const [IsEdit, setIsEdit] = useState(false);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(gelEmployeesAction());
  }, []);

  const handleSerach = (e) => {
    dispatch(gelEmployeesAction(`national_id=${e.target.value}`));
  };
  const handlesubmit = async (e) => {
    e.preventDefault();
    if (
      Name === "" ||
      Phone === "" ||
      Email === "" ||
      Nationalid === "" ||
      Address === ""
    ) {
      notify("من فضلك اكمل البيانات المطلوبة", "error");
      return;
    }
    if (Nationalid.length < 14 || Nationalid.length > 14) {
      notify("يجب ادخال رقم قومي صحيح", "error");
      return;
    }
    setisPress(true);

    await dispatch(
      createNewEmpAction({
        username: Name,
        email: Email,
        national_id: Nationalid,
        mobile: Phone,
        // language: "A",
        // add_new_employee: NewEmp.toString(),
        // car_management: Car.toString(),
        // tourists: Tourist.toString(),
        user_type: "consultant",
        address: Address,
      })
    );
    setEmpId("");
    setName("");
    setNationalid("");
    setPhone("");
    setAddress("")
    setEmail("");
    setDeleteEmp(false);
    setLoading(false);
    setisPress(false);
  };
  const handlesubmitUpdate = async (e) => {
    e.preventDefault();
    // if (
    //   Name === "" ||
    //   Phone === "" ||
    //   Email === "" ||
    //   Nationalid === "" ||
    //   EmpType === ""
    // ) {
    //   notify("من فضلك اكمل البيانات المطلوبة", "error");
    //   return;
    // }
    // if (Nationalid.length < 14 || Nationalid.length > 14) {
    //   notify("يجب ادخال رقم قومي صحيح", "error");
    //   return;
    // }
    setisPress(true);
    await dispatch(
      UpdateEmpAction({
        employee_id: EmpId,
        delete_employee: DeleteEmp,
      })
    );
    setLoading(false);
    setisPress(false);
    setIsEdit(false);
    setEmpId("");
    setName("");
    setAddress("")
    setNationalid("");
    setPhone("");
    setEmail("");
    setDeleteEmp(false);
  };
  const update = (item) => {
    setIsEdit(true);
    setEmpId(item.id);
    setName(item.username);
    setNationalid(item.national_id);
    setEmpId(item.id);
    setPhone(item.mobile);
    setEmail(item.email);
    setAddress(item.address);
  };
  const res = useSelector((state) => state.ManageEmpReduser.createEmp);
  const All = useSelector((state) => state.ManageEmpReduser.getAllEmp);
  const Update = useSelector((state) => state.ManageEmpReduser.updateAdmiEmp);

  useEffect(() => {
    if (loading === false) {
      setTimeout(() => setLoading(true), 1500);
      if (res) {
        if (res.status === 200 || res.status === 201) {
          if (res.data) {
            notify(res.data.message, "success");
            dispatch(gelEmployeesAction());
          }
        } else if (res.status !== 200 || res.status !== 201) {
          if (res.data) {
            res.data.message.map((item) => notify(item, "error"));
            dispatch(gelEmployeesAction());
          } else {
            notify("حدث خطأ حاول مرة اخرى", "error");
            dispatch(gelEmployeesAction());
          }
        }
      }
      if (Update) {
        if (Update.status === 200 || Update.status === 201) {
          if (Update.data) {
            notify(Update.data.message, "success");
            dispatch(gelEmployeesAction());
          }
        } else if (Update.status !== 200 || Update.status !== 201) {
          if (Update.data) {
            notify(Update.data.message, "error");
            dispatch(gelEmployeesAction());
          } else {
            notify("حدث خطأ حاول مرة اخرى", "error");
            dispatch(gelEmployeesAction());
          }
        }
      }
    }
  }, [loading]);
  return (
    <>
      <Container>
        <h4 className="text-center mt-3 mb-3">إدارة الموظفين</h4>
        <div className="inputs-container">
          <div className="inp-container ">
            <TextField
              focused
              label={
                <Typography>
                  اسم المستخدم
                  <span style={{ color: "red", fontSize: "21px" }}>*</span>
                </Typography>
              }
              onChange={(e) => setName(e.target.value)}
              variant="outlined"
              value={Name}
              disabled={IsEdit}
            />
          </div>
          <div className="inp-container ">
            <TextField
              label={
                <Typography>
                  الرقم القومي
                  <span style={{ color: "red", fontSize: "21px" }}>*</span>
                </Typography>
              }
              type="number"
              value={Nationalid}
              onChange={(e) => setNationalid(e.target.value)}
              variant="outlined"
              disabled={IsEdit}
            />
          </div>
          <div className="inp-container ">
            <TextField
              label={
                <Typography>
                  العنوان
                  <span style={{ color: "red", fontSize: "21px" }}>*</span>
                </Typography>
              }
              type="text"
              value={Address}
              onChange={(e) => setAddress(e.target.value)}
              variant="outlined"
              disabled={IsEdit}
            />
          </div>
          <div className="inp-container ">
            <TextField
              label={
                <Typography>
                  رقم الهاتف
                  <span style={{ color: "red", fontSize: "21px" }}>*</span>
                </Typography>
              }
              type="number"
              value={Phone}
              onChange={(e) => {
                setPhone(e.target.value);
              }}
              variant="outlined"
              disabled={IsEdit}
            />
          </div>
          <div className="inp-container ">
            <TextField
              label={
                <Typography>
                  البريد الألكتروني
                  <span style={{ color: "red", fontSize: "21px" }}>*</span>
                </Typography>
              }
              type="email"
              value={Email}
              onChange={(e) => setEmail(e.target.value)}
              variant="outlined"
              disabled={IsEdit}
            />
          </div>
          {/* <div className="inp-container">
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">
                <Typography>
                  نوع الحساب
                  <span style={{ color: "red", fontSize: "21px" }}>*</span>
                </Typography>
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={EmpType}
                label={
                  <Typography>
                    نوع الحساب
                    <span style={{ color: "red", fontSize: "21px" }}>*</span>
                  </Typography>
                }
                onChange={(e) => setEmpType(e.target.value)}
              >
                <MenuItem value={"admin"}>ادمن</MenuItem>
                <MenuItem value={"consultant"}>مستشار</MenuItem>
              </Select>
            </FormControl>
          </div> */}
          <div className="inp-container d-flex">
            {IsEdit ? (
              <div className="container-checkbox ">
                <input
                  type="checkbox"
                  className="check-box"
                  onChange={(e) => setDeleteEmp(e.target.checked)}
                  checked={DeleteEmp}
                />
                حذف الموظف
              </div>
            ) : null}
          </div>

          <div className="inp-container "></div>

          <div className="inp-container "></div>
        </div>
        {loading && isPress ? (
          <button className="buttonadd">
            <Spinner />
          </button>
        ) : IsEdit ? (
          <button className="buttonadd" onClick={handlesubmitUpdate}>
            تعديل
          </button>
        ) : (
          <button className="buttonadd" onClick={handlesubmit}>
            إضافة
          </button>
        )}
        <hr />
        <div className="search-bar mt-3">
          {" "}
          <TextField
            label="البحث بالرقم القومي"
            onChange={handleSerach}
            type="number"
            variant="outlined"
          />
          <i className="ty fa-solid fa-magnifying-glass"></i>
        </div>
        <Table className="maint" responsive striped bordered hover>
          <thead>
            <tr>
              <th>
                الأسم <i className="fa-solid fa-user"></i>
              </th>
              <th>
                الرقم القومي <i className="fa-solid fa-address-card"></i>
              </th>
              <th>
                رقم الهاتف <i className="fa-solid fa-mobile-screen-button"></i>
              </th>
              <th>
                البريد الألكتروني <i className="fa-regular fa-envelope"></i>
              </th>
              <th>
                نوع المستخدم<i className="fa-solid fa-file-signature"></i>
              </th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {All && All.length >= 0
              ? All.map((item, idx) => (
                  <tr key={idx}>
                    <td>{item.username}</td>
                    <td>{item.national_id}</td>
                    <td>{item.mobile}</td>
                    <td>{item.email}</td>
                    <td>موضف</td>
                    <td className="icon-w">
                      <i
                        onClick={() => update(item)}
                        className="fa fa-solid fa-pen-to-square"
                        style={{ color: "rgb(0 44 146)" }}
                      ></i>
                    </td>
                    {/* <td className="icon-w">
                      {" "}
                      <i
                        className="fs fa-solid fa-trash-can"
                        style={{ color: "red" }}
                      ></i>
                    </td> */}
                  </tr>
                ))
              : null}
          </tbody>
        </Table>
        <ToastContainer />
      </Container>
    </>
  );
};

export default Employee;
